import { lazy } from 'react';

const AlumniAccountInvitation = lazy(() =>
  import('./pages/AlumniLandingPage/components/AlumniAccountInvitation'),
);
const AttendanceRecordModal = lazy(() =>
  import('./pages/AlumniList/components/AttendanceRecordModal'),
);

export default {
  ALUMNI_ACCOUNT_INVITATION: AlumniAccountInvitation,
  ATTENDANCE_RECORD_MODAL: AttendanceRecordModal,
};
